import {ConsumptionPageLoader} from "./ConsumptionPageLoader.tsx";
import StatusPageConsumption from "./StatusPageConsumption.tsx";
import {useHostResolvedSlug} from "./useHostResolvedSlug.ts";

// App-root entry point. On a customer custom domain there is no slug in the URL, so
// resolve the current host to an SPA-served status-page slug and render it in place (the
// URL stays clean). A non-SPA, unresolved, or failed lookup falls through to the
// not-found view. hostMode keeps navigation clean and redirects on-domain.
export const HostStatusPage = () => {
  const {slug, loading} = useHostResolvedSlug();

  if (loading) {
    return <ConsumptionPageLoader />;
  }

  return <StatusPageConsumption slug={slug} hostMode />;
};
